import { blotterTypeFilters } from 'components/Blotters/Filter/BlotterFilterNext.helpers';
import { DropdownWrapper, SpDropdownItem } from 'components/shared/Dropdown';
import { FC } from 'react';
import { DropdownMenu, DropdownToggle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { FilterBlotterType } from 'state/blotters/trades/types/types';

interface BlotterTypeFilterProps {
  value: FilterBlotterType;
  onSelect: (value: FilterBlotterType) => void;
}
export const BlotterTypeFilter: FC<BlotterTypeFilterProps> = ({ value, onSelect }) => {
  return (
    <DropdownWrapper className="btn-group border-start border-opacity-40" openOnHover>
      <DropdownToggle
        variant="link"
        aria-haspopup="listbox"
        data-e2e="blotter-type-filter"
        className="btn btn-flat-secondary btn-lg btn-icon-start dropdown-toggle pe-2"
      >
        <i className="icon">menu</i>
        <span className="d-none d-lg-inline">
          <FormattedMessage id={`blotter.filter.blotterType.${value}`} />
        </span>
      </DropdownToggle>
      <DropdownMenu role="listbox">
        {blotterTypeFilters.map(blotterType => (
          <SpDropdownItem active={blotterType === value} key={blotterType} onClick={() => onSelect(blotterType)}>
            <FormattedMessage id={`blotter.filter.blotterType.${blotterType}`} />
          </SpDropdownItem>
        ))}
      </DropdownMenu>
    </DropdownWrapper>
  );
};
